import { useDispatch, useSelector } from 'react-redux';
import { Box, Dropdown, Text } from '@quintoandar-tokko/jopijs';
import mapCurrencyFlags from 'src/utils/mapCurrencyFlags';
import { setOverviewOperationStatistics } from '@/store/slices/components/dashboard/DashboardSlice';
import ImageNext from '@/components/shared/ImageNext';
import styles from '../totalValueCard.module.scss';

export default function CurrencyDropdown() {
  const { currencies, selectedCurrency } = useSelector(
    (state) => state.DashboardSlice.overviewOperationStatistics
  );
  const dispatch = useDispatch();
  const dropdownOptions = mapCurrencyFlags(currencies);
  const selectedFlag = dropdownOptions.find(
    (option) => option.id === selectedCurrency
  )?.flag;

  const handleChange = (currency) => {
    dispatch(
      setOverviewOperationStatistics({
        key: 'selectedCurrency',
        value: currency,
      })
    );
  };

  return (
    <Dropdown className={styles.dd}>
      <Dropdown.Button
        variant="dropdownOutlined"
        text={
          <Box className={styles.ddButtonContent}>
            {selectedFlag && (
              <ImageNext alt={selectedCurrency} src={selectedFlag} />
            )}

            <Text>{selectedCurrency}</Text>
          </Box>
        }
      />
      <Dropdown.Items className={styles.ddItems} clickClose>
        {dropdownOptions.map((option) => (
          <Dropdown.Default
            key={option.id}
            onClick={() => handleChange(option.id)}
          >
            <Box className={styles.ddItem}>
              {option?.flag && (
                <ImageNext alt={`flag-${option.id}`} src={option?.flag} />
              )}
              <Text>{option.id}</Text>
            </Box>
          </Dropdown.Default>
        ))}
      </Dropdown.Items>
    </Dropdown>
  );
}
